import * as AuthorQuoteStyles from '../../../styles/products/author-quote.module.scss';
import PropTypes from 'prop-types';
import React from 'react';
import dompurify from 'isomorphic-dompurify';

const AuthorQuote = ({
  imageRight,
  imageLeft,
  name,
  text,
  jobPosition,
  jobPositionDetail
}) => {
  const sanitizer = dompurify.sanitize;

  return (
    <div className={AuthorQuoteStyles.root}>
      {imageLeft &&
      <div className={AuthorQuoteStyles.imageContainerLeft}
        dangerouslySetInnerHTML={{__html:
          imageLeft
        }}
      >
      </div>}
      <div className={AuthorQuoteStyles.content}>
        <div className={AuthorQuoteStyles.detailContainer}>
          <span
            className={AuthorQuoteStyles.caractere}
            dangerouslySetInnerHTML={{
              __html: '&laquo '
            }}
          />
          <span
            className={AuthorQuoteStyles.detailText}
            dangerouslySetInnerHTML={{
              __html: sanitizer(text)
            }}
          />
          <span
            className={AuthorQuoteStyles.caractere}
            dangerouslySetInnerHTML={{
              __html: ' &raquo'
            }}
          />
        </div>
        <p
          className={AuthorQuoteStyles.name}
          dangerouslySetInnerHTML={{
            __html: name
          }}
        />
        <p
          className={AuthorQuoteStyles.jobPosition}
          dangerouslySetInnerHTML={{
            __html: jobPosition
          }}
        />
        <span
          className={AuthorQuoteStyles.jobPositionDetail}
          dangerouslySetInnerHTML={{
            __html: sanitizer(jobPositionDetail)
          }}
        />
      </div>
      {imageRight &&
      <div className={AuthorQuoteStyles.imageContainerRight}
        dangerouslySetInnerHTML={{__html: imageRight
        }}
      >
      </div>}
    </div>
  );
};

AuthorQuote.propTypes = {
  imageCredit: PropTypes.string,
  imageLeft: PropTypes.string,
  imageRight: PropTypes.string,
  jobPosition: PropTypes.string.isRequired,
  jobPositionDetail: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default AuthorQuote;
